<template>
  <el-popover
    v-model:visible="isOpen"
    placement="bottom-start"
    trigger="hover"
    :popper-style="{ width: 'auto' }"
    :show-arrow="false"
    :popper-class="['c-header-popper', theme || injectTheme || routeTheme]"
  >
    <template #reference>
      <div class="more-business text-sm-m cursor-pointer flex-row items-center">
        <span>{{ $t('更多') }}</span>
        <i :class="{ active: isOpen }" class="icon-arrow-b w16 h16" />
      </div>
    </template>
    <!-- 更多业务 -->
    <div class="more-list">
      <div v-for="(item, index) in showList" :key="index">
        <router-link :to="item.link" @click="eventTrack({ name: item.eventTrackName })">
          <div class="more-item flex-row items-center text-sm-m hk-header-color-3">
            {{ item.text }}
          </div>
        </router-link>
      </div>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import eventTrack from '@/utils/eventTracking';
import { PropType } from 'vue';
const route = useRoute();

const props = defineProps({
  theme: {
    type: String,
    default: ''
  },
  list: {
    type: Array as PropType<Array<any>>,
    default: () => []
  }
});
const isOpen = ref(false);
const injectTheme = inject('theme');
const routeTheme = computed(() => {
  const routeProps: any = route.meta.props;
  return routeProps?.header?.theme;
});
const showList = computed(() => props.list.filter(item => !item.hide));
</script>

<style scoped lang="scss">
.dark .more-business {
  span {
    color: var(--gray-25);
    &:hover,
    &.active {
      color: var(--gray-200);
    }
  }
}

.more-business {
  white-space: nowrap;
  span {
    color: var(--gray-700);
    &:hover,
    &.active {
      color: var(--gray-900);
    }
  }

  .triangle-icon {
    color: var(--gray-400) !important;
    transition: 0.15s all linear;
  }

  // 控制有下拉菜单选项的 icon
  &[aria-describedby] {
    .triangle-icon {
      transform: rotate(180deg);
    }
  }
}

.more-list {
  padding: 12px;
  border-radius: 8px;

  .more-item {
    padding: 0 8px;
    height: 52px;
    border-radius: 8px;

    &:hover {
      background: var(--hk-header-color-4);
    }
  }
}
</style>
